import React from "react";
import { DialogContent, DialogActions, Button } from "@mui/material";
import {
  AddComment,
  EditNote,
  FileUploadOutlined,
  CachedOutlined,
} from "@mui/icons-material";
import usePhotosDialogStyles from "./css/usePhotosDialogStyles";

interface PhotoPreviewProps {
  photo: string;
  hasComment: boolean;
  onAddComment: () => void;
  onUpload: () => void;
  onRestart: () => void;
  onCancel: () => void;
  t: (key: string, fallback?: string) => string;
}

const PhotoPreview: React.FC<PhotoPreviewProps> = ({
  photo,
  hasComment,
  onAddComment,
  onUpload,
  onRestart,
  onCancel,
  t,
}) => {
  const { classes } = usePhotosDialogStyles();

  return (
    <>
      <DialogContent className={classes.previewContent}>
        <img
          src={photo}
          alt="Nuotrauka"
          style={{ width: "100%", height: "auto" }}
        />

        <Button
          startIcon={hasComment ? <EditNote /> : <AddComment />}
          className={classes.addCommentButton}
          onClick={onAddComment}
        >
          {hasComment
            ? t("editComment", "Redaguoti komentarą")
            : t("addComment", "Pridėti komentarą")}
        </Button>
      </DialogContent>
      <DialogActions className={classes.photoActions}>
        <Button
          color="primary"
          onClick={onUpload}
          startIcon={<FileUploadOutlined />}
        >
          {t("uploadImage", "Įkelti")}
        </Button>
        <Button
          color="inherit"
          startIcon={<CachedOutlined />}
          onClick={onRestart}
          sx={{ textTransform: "none" }}
        >
          {t("takePhotoAgain", "Fotografuoti iš naujo")}
        </Button>
        <Button
          color="inherit"
          onClick={onCancel}
          sx={{ textTransform: "none" }}
        >
          {t("cancelDialog", "Atšaukti")}
        </Button>
      </DialogActions>
    </>
  );
};

export default PhotoPreview;
